<template>
    <div
        v-if="show"
        class="tw:fixed tw:inset-0 tw:z-50 tw:flex tw:items-center tw:justify-center"
    >
        <div
            class="tw:fixed tw:inset-0 tw:bg-black tw:bg-opacity-50"
            @click="confirmar"
        ></div>

        <div class="tw:relative tw:bg-white tw:rounded-xl tw:shadow-2xl tw:z-10 tw:max-w-md tw:w-full tw:mx-4 tw:p-6">
            <h3 class="tw:text-lg tw:font-semibold tw:text-gray-900 tw:mb-4">
                Cerrando butacas
            </h3>

            <p class="tw:text-sm tw:text-gray-600 tw:mb-6">
                Las butacas se están cerrando. Recibirás una notificación cuando termine.
            </p>

            <div class="tw:flex tw:justify-end">
                <Button
                    variant="primary"
                    @click="confirmar"
                >
                    Aceptar
                </Button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import Button from '@/modules/admin/ui/Button.vue';

    defineProps({
        show: { type: Boolean, default: false }
    });

    const emit = defineEmits(['confirmar']);

    function confirmar() {
        emit('confirmar');
    }
</script>
